import React, { useRef } from 'react'
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js'
import { useAuthStore } from '../store'
const PayPalCheckout = ({ amount, onApprove }) => {
  const baseUrl = process.env.REACT_APP_API_URL
  const calledRef = useRef(false) // onApprove 중복 호출 방지
  const { user } = useAuthStore()
  // 서버에서 오더 생성
  const createOrder = async () => {

    const res = await fetch(`${baseUrl}/create-paypal-order`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ amount: String(amount) }),
    })
    if (!res.ok) {
      const txt = await res.text().catch(() => '')
      throw new Error(`[create-paypal-order] ${res.status} ${txt}`)
    }
    const data = await res.json()
    if (!data?.orderID) {
        throw new Error('Missing orderID from server')
    }
    return data.orderID
  }

  // 승인 후 캡처 + 부모 콜백
  const handleApprove = async (data) => {
    if (calledRef.current) {
      console.warn('[PAYPAL] duplicated onApprove ignored')
      return
    }
    calledRef.current = true

    try {
      const res = await fetch(`${baseUrl}/capture-paypal-order`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ orderID: data.orderID }),
      })
      if (!res.ok) {
        const txt = await res.text().catch(() => '')
        throw new Error(`[capture-paypal-order] ${res.status} ${txt}`)
      }
      const payload = await res.json()
      console.log('[PAYPAL] capture payload:', payload)

      // 부모 콜백으로 캡처 결과 전달 (orderID 포함)
      if (typeof onApprove === 'function') {
        await onApprove({
          orderID: data.orderID,
          capture: payload.captureResult ?? payload,
        })
      } else {
        console.warn('[PAYPAL] parent onApprove is not a function')
      }
    } catch (e) {
      calledRef.current = false // 실패 시 재시도 허용
      console.error('[PAYPAL] onApprove error:', e)
      throw e // PayPal 버튼에 에러 전파(내부 UI 처리)
    }
  }

  const handleError = (err) => {
    console.error('[PAYPAL] Buttons error:', err)
  }

  return (
    <PayPalScriptProvider
      options={{
        'client-id':
          'AcvKC3LLYbQC7au57OW16O-HpRqynSHpJkcrox6rUTWxEPdgqB--mJse2dOkDw9uYu11zDPmRKGXnEpL',
        currency: 'USD',
        intent: 'capture',
        locale: 'en_US',
      }}
    >
      <PayPalButtons
        // ✅ 반드시 Promise/값을 return 하도록 함수 자체를 넘김
        createOrder={createOrder}
        onApprove={handleApprove}
        onError={handleError}
        style={{ layout: 'vertical' }}
      />
    </PayPalScriptProvider>
  )
}

export default PayPalCheckout
